import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FavoritepagesPage } from './favoritepages';

@NgModule({
  declarations: [
    FavoritepagesPage,
  ],
  imports: [
    IonicPageModule.forChild(FavoritepagesPage),
  ],
})
export class FavoritepagesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/favoritepages/favoritepages.module.ts